export default __webpack_public_path__ + "static/media/icon-heart-full.4fbe3c19.svg";